export default __webpack_public_path__ + "static/media/Rubik-Medium.2d7c3aac.woff";